import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ErrorHandlingContext } from "../../context/error-handling.context";

// Shared by the login, register, and forgot-password flows so every
// mutation error (whatever its __typename) surfaces the same way: a global
// toast with the server's message, falling back to a generic one. Having a
// single place for this means a new auth flow can't silently forget to
// alert the user on failure the way the old per-form implementations did.
export const useAuthErrorAlert = () => {
  const { t } = useTranslation();

  const { setErrorHandlingState } = useContext(
    ErrorHandlingContext
  ) as unknown as {
    setErrorHandlingState: (state: { showError: boolean; data: string }) => void;
  };

  return (message?: string | null) => {
    setErrorHandlingState({
      showError: true,
      data: message || t("errors.generic"),
    });
  };
};
